<template>
    <div class="container mb-3">
        <div class="row justify-content-center" v-for="(data, index) in blog" :key="index">

            <!-- 8 column centered -->
            <div class="col-8 mt-3 text-start">
                <p class="text-left">
                    <span style="background-color: #e6e7ea; padding: 10px; border-radius: 5px; cursor: pointer" @click="this.$router.push({name: 'Blog'})" >{{ data.category }}</span>
                    &nbsp;<span>&nbsp;<i class="fa fa-calendar-alt"></i>&nbsp;{{ formatDate(data.publishDate) }}</span>
                </p>
                <div class="heading d-block mt-2">
                    <h1 class="fw-bolder" style="text-align: left; font-family: 'Times New Roman'">{{ data.contentTitle
                        }}</h1>
                </div>
            </div>

            <!-- 8 column centered card -->
            <div class="col-8 mt-2">
                <div class="row mt-2" style="padding: 0 20px 0 20px">
                    <div class="col-12">
                        <div style="width: 100%; height: 450px; overflow: hidden;">
                            <img
                                    :src="getImagePath() + data.imageUrl"
                                    :alt="data.altText || 'Image'"
                                    style="width: 100%; height: 100%; object-fit: cover; object-position: center;"
                                    class="bx-border-radius"
                            />
                        </div>
                    </div>
                    <!-- Table of Contents -->
                    <div class="col-4 mt-5 text-start">
                        <div class="toc-box">
                            <div class="toc-header">
                                <i class="fa fa-list"></i> Table of Contents
                            </div>
                            <ul class="toc-list">
                                <li v-for="(item, index) in tableOfContents" :key="index" class="border p-3">
                                    <a :href="'#' + item.id" @click.prevent="scrollToHeading(item.id)">
                                        <span class="toc-number">{{ index + 1 }}.</span> {{ item.text }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- Blog Content -->
                    <div class="col-8 mt-2 text-start">
                        <div class="mt-5 blog-content" v-html="data.plainContent" ref="blogContent"></div>
                    </div>
                </div>
            </div>

        </div>
        <div class="justify-content-center row mt-4">
            <div class="col-10">
                <h1 class="fw-bolder mb-4 font-monospace">Explore more inspirational content.</h1>
                <div class="row">
                    <div class="col-4" v-for="(ctg, index) in ctgWiseBlogs" :key="index"
                         @click="goToDetail(ctg.requestKey)"
                         style="cursor: pointer;">

                        <img
                                :src="getImagePath() + ctg.imageUrl"
                                :alt="ctg.altText || 'Image'"
                                class="bx-border-radius explore-img"
                        />
                        <h6 class="fw-bolder font-monospace text-start mt-4 mb-2">{{ ctg.contentTitle }}</h6>
                        <p class="text-start mb-2 mt-2">
                            <span>{{ ctg.category }}</span> |
                            &nbsp;<span>&nbsp;<i class="fa fa-calendar-alt"></i>&nbsp;{{ formatDate(ctg.publishDate) }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiRepository, {getImage} from "@/services/apiRepository";

    export default {
        name: "BlogDetails",
        data() {
            return {
                lang: null,
                tableOfContents: [],
                blog: [],
                imageUrlGet: null,
                timeRemaining: '',
                timer: null,
                publishData: null,
                allBlog: null,
                ctgWiseBlogs: []
            };
        },
        watch: {
            blog: {
                handler(newVal) {
                    if (newVal && newVal.length > 0) {
                        this.$nextTick(() => {
                            this.generateTableOfContents();
                        });
                    }
                },
                immediate: true,
                deep: true
            },
            '$route.params.id': {
                handler(newId) {
                    if (newId) {
                        this.getBlogById(newId);
                        this.getRecentPost();
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    }
                },
                immediate: false
            }
        },
        mounted() {
            this.langData();
            const id = this.$route.params.id;

            this.getBlogById(id);
            this.startCountdown();
            this.getRecentPost();
        },
        beforeUnmount() {
            clearInterval(this.timer);
        },
        methods: {
            langData() {
                const langu = localStorage.getItem("locale");
                this.lang = langu;
            },
            goToDetail(requestKey) {
                this.$router.push({name: 'BlogDetails', params: {id: requestKey}}).then(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                });
            },
            generateTableOfContents() {
                let blogContent = this.$refs.blogContent;
                if (!blogContent) return;

                if (Array.isArray(blogContent)) {
                    blogContent = blogContent[0];
                }
                if (blogContent.$el) {
                    blogContent = blogContent.$el;
                }

                const headings = blogContent.querySelectorAll('h2, h3');
                this.tableOfContents = [];

                headings.forEach((heading, index) => {
                    const id = 'heading-' + index;
                    heading.setAttribute('id', id);
                    this.tableOfContents.push({
                        id: id,
                        text: heading.innerText,
                        tag: heading.tagName
                    });
                });
            },

            scrollToHeading(id) {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
            },

            formatDate(dateStr) {
                if (!dateStr) return '';
                const date = new Date(dateStr);
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            },

            getImagePath() {
                return getImage(); // this will call the imported function
            },
            getBlogById(id) {
                try {
                    apiRepository.callApi(apiRepository.GET_COMMAND, `/getBlogContents?requestKey=${id}&lang=${this.lang}`).then((res) => {
                        this.blog = res.data;
                        this.relatedPosts(this.blog[0].categoryId);
                        this.startCountdown();
                    });
                } catch (error) {
                    console.error(error.response?.data || error.message);
                }
            },
            getRecentPost() {
                try {
                    apiRepository.callApi(apiRepository.GET_COMMAND, `/getRecentBlogContents`).then((res) => {
                        this.allBlog = res.data;
                    });
                } catch (error) {
                    console.error(error.response?.data || error.message);
                }
            },
            startCountdown() {
                this.updateCountdown();
                this.timer = setInterval(this.updateCountdown, 60000); // Update every minute
            },
            relatedPosts(id) {
                apiRepository.callApi(apiRepository.GET_COMMAND, `/getBlogContents?category=${id}&lang=${this.lang}`).then(res => {
                    if (res) {
                        this.ctgWiseBlogs = res.data
                    }
                })
            },
            updateCountdown() {
                if (!this.publishData) return;

                const now = new Date();
                const publish = new Date(this.publishData);

                if (now <= publish) {
                    this.timeRemaining = 'Published';
                    return;
                }

                const isToday =
                    now.getFullYear() === publish.getFullYear() &&
                    now.getMonth() === publish.getMonth() &&
                    now.getDate() === publish.getDate();

                if (isToday) {
                    this.timeRemaining = 'Today';
                    return;
                }
                const diffTime = now - publish;
                const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

                this.timeRemaining = `${totalDays} day${totalDays === 1 ? '' : 's'} left`;
            }


        }
    };
</script>
<style scoped>
    .toc-box {
        position: sticky;
        top: 100px;
        background-color: #f9f9f9;
        border: 1px solid #e0e0e0;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    .toc-header {
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 14px;
        color: #1a1a1a;
        border-bottom: 2px solid #077747;
        padding-bottom: 8px;
    }

    .toc-header i {
        color: #077747;
        margin-right: 6px;
    }

    .toc-list {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .toc-list li {
        margin-bottom: 10px;
    }

    .toc-list li a {
        text-decoration: none;
        color: #333;
        font-size: 14px;
        display: flex;
        align-items: flex-start;
        gap: 6px;
        line-height: 1.5;
        transition: color 0.2s;
    }

    .toc-list li a:hover {
        color: #077747;
    }

    .toc-number {
        color: #077747;
        font-weight: 600;
        min-width: 20px;
    }

    /* Blog content images */
    :deep(.blog-content) img {
        display: block;
        margin: 16px auto;
        width: 100%;
        max-width: 500px;
        height: auto;
        object-fit: cover;
        border-radius: 6px;
    }

    /* Add scroll margin for headings so sticky header doesn't cover them */
    :deep(.blog-content) h2,
    :deep(.blog-content) h3 {
        scroll-margin-top: 100px;
    }

    /* .recent-content {
         padding: 8px;
         list-style-type: none;
         text-align: left;
         box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
         border-radius: 5px;

     }

     .recent-content a {
         text-decoration: none;
         color: #2c3e50;
     }

     .recent-content a:hover {
         color: #d75757;
     }*/
    :deep(.blog-content) img {
        display: block;
        margin: 0 auto;
        width: 100%;
        max-width: 800px;
        height: auto;
        object-fit: cover;
        border-radius: 6px;
    }

    .explore-img {
        width: 100%;
        height: 250px;
        object-fit: cover;
        border-radius: 8px;
    }

</style>
